export default __webpack_public_path__ + "static/media/ProximaNova-Semibold.dfa26f09.ttf";